<template>
    <div>
        <div @resize="resizeIframe()">
            <iframe id="training-iframe" width="100%" src="./hcpTraining.html" frameborder="0" scrolling="no" style="height:100vh; border:none;" @load="iframeLoaded()"></iframe>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'HCPTraining',

    components: {

    },

    data() {
        return {
            resizeTimeout: true
        }
    },

    created()  {
        window.addEventListener("resize", this.resizeIframe);
        window.addEventListener('message', this.submitForm, false);
    },

    destroyed()  {
        window.removeEventListener("resize", this.resizeIframe);
        window.removeEventListener('message', this.submitForm, false);
    },

    mounted() {
        this.$modal.hideAll()
    },

    computed: {
        ...mapGetters({
            organisationId: 'UserStore/GetUserOrganisationId',
            practitionerTrainingUpToDate: 'UserStore/GetTrainingUpToDate'
        })
    },

    methods: {
        ...mapActions({
            setSelectAPatientSearchbarDataInSearchStore: 'SearchStore/SetSelectAPatientSearchbarData',
            setNotification: 'NotificationStore/SetNotification',
            updatePractitionerTrainingDetails: 'UserStore/UpdatePractitionerTrainingDetails',
        }),

        iframeLoaded() {
            if (this.practitionerTrainingUpToDate) {
                let trainingForms = window.frames['training-iframe'].contentDocument.getElementsByClassName("training-complete")
                for (var x = 0; x < trainingForms.length; x++)
                {
                    let parentRow = trainingForms[x].closest(".dnd-section")
                    if (parentRow != null) {
                        parentRow.style.display = 'none';
                    }
                }
            }

            this.resizeIframe()
        },
        resizeIframe() {
            if (this.resizeTimeout) {
                clearTimeout(this.heightTimeout);
                this.resizeTimeout = setTimeout(()  =>  {
                    var obj = document.getElementById("training-iframe")
                    var newHeight = 100 + obj.contentWindow.document.documentElement.offsetHeight
                    obj.style.height = newHeight + 'px'
                },  150)
            }
        },
        async submitForm(e) {
            if (e == null || e.data == null || typeof e.data !== 'string') return
            if (!e.data.startsWith('TrainingFormSubmission')) return
            let splitFormVals = e.data.split(",")
            let reviewedChecked = splitFormVals[1] === "true";
            let understoodChecked = splitFormVals[2] === "true";
            let trainingReviewedErrors = window.frames['training-iframe'].contentDocument.getElementsByClassName("training-reviewed-error")
            let trainingUnderstoodErrors = window.frames['training-iframe'].contentDocument.getElementsByClassName("training-understood-error")
            for (var i = 0; i < trainingReviewedErrors.length; i++)
            {
                trainingReviewedErrors[i].style.display = reviewedChecked ? "none" : "block"
            }
            for (var j = 0; j < trainingUnderstoodErrors.length; j++)
            {
                trainingUnderstoodErrors[j].style.display = understoodChecked ? "none" : "block"
            }
            // Update the hcp training properties
            if (reviewedChecked && understoodChecked) {
                await this.updateTrainingRecord()
            }
        },
        async updateTrainingRecord() {
            try {
                await this.updatePractitionerTrainingDetails(this.organisationId)

                this.setNotification({
                    type: 'success',
                    title: 'Success',
                    message: 'Training completed'
                })

                return this.$router.push({name: 'Dashboard'})

            }
            catch {
                this.setNotification({
                    type: 'error',
                    title: 'Error',
                    message: 'Something went wrong. Please try again'
                })
            }
        }
    }

}
</script>